import React from "react";
import { Link } from "gatsby";

function AboutIntro() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-6">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-xl text-gray-600 mb-4">
              {/* Sustainable solutions are fundamentally better. They are better
              for the planet, better for people, and better for business. */}
              Advancing climate solutions takes conviction, commitment, and
              courage. We collaborate with the world's most innovative
              organizations to scale solutions with the highest likelihood of
              genuine impact.
            </h1>

            <p className="text-xl text-gray-600">
              This drives our <b>mission to help climate solutions win</b> so we
              can build a sustainable future where both humanity and this planet
              thrive. Read on to learn more about Rho Impact, our origin story,
              and{" "}
              <Link
                to="/impact/"
                className="text-blue-500 hover:text-blue-700 font-medium"
                href="#0"
              >
                how we make direct contributions to the field
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutIntro;
